export const demoMode = !!process.env.HITPOINTS_DEMO;
